import { Check } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { SITE, isPlaceholder } from "@/config/site";
import { CtaButton } from "./CtaButton";

const LIST = ["Kits prontos para revenda", "Bônus: Pack Canva Educacional Editável", "Bônus: Guia Completo para Revender PLR", "Bônus: Pack Artes para Divulgação", "Suporte via WhatsApp"];

export const UpsellModal = ({ open, onOpenChange }) => {
  const declineClick = (e) => {
    if (isPlaceholder(SITE.checkout.basic)) {
      e.preventDefault();
      toast("Link de checkout ainda não configurado", { description: `Substitua ${SITE.checkout.basic} em src/config/site.js` });
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md overflow-hidden rounded-[28px] border-0 p-0" data-testid="upsell-modal">
        <div className="bg-rose px-7 pb-6 pt-8 text-white">
          <DialogTitle className="font-display text-2xl font-extrabold leading-tight">Espere! Leve o Premium por só {SITE.upsell.label}</DialogTitle>
          <DialogDescription className="mt-1 text-white/90">Kits prontos para revenda + 3 bônus</DialogDescription>
        </div>
        <div className="px-7 pb-7 pt-6">
          <p className="font-display text-5xl font-extrabold text-ink">{SITE.upsell.extra}</p>
          <p className="text-sm text-ink/60">total de {SITE.upsell.total} em pagamento único</p>
          <ul className="mt-5 space-y-2.5">
            {LIST.map((t) => <li key={t} className="flex items-start gap-2 text-sm text-ink"><Check className="mt-0.5 h-4 w-4 shrink-0 text-mint" />{t}</li>)}
          </ul>
          <CtaButton href={SITE.checkout.upsellPremium} testId="upsell-accept-button" className="mt-6 w-full !px-4 !text-sm">Sim, quero o Premium por {SITE.upsell.label}</CtaButton>
          <a href={isPlaceholder(SITE.checkout.basic) ? "#" : SITE.checkout.basic} target="_blank" rel="noopener noreferrer" onClick={declineClick}
            className="mt-4 block text-center text-sm text-ink/60 underline underline-offset-4 hover:text-ink" data-testid="upsell-decline-button">
            Não, quero continuar com o Básico por {SITE.basic.label}
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
